import { NgFor } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import {
  AbstractDialogResultData,
  AbstractFormDialog,
  AbstractFormDialogData,
  FormDialogComponent,
} from '@next/core-lib/dialog';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';

import { FeedAdviceType, FeedAdviceTypeMenuItem } from '../../models/feed-advice.model';

export interface FeedAdviceTypeDialogInputData extends AbstractFormDialogData {
  feedAdviceTypes: FeedAdviceTypeMenuItem[];
}

export interface FeedAdviceTypeDialogResultData {
  feedAdviceType: FeedAdviceTypeMenuItem;
}

@Component({
  selector: 'app-feed-advice-type-dialog',
  templateUrl: './feed-advice-type-dialog.component.html',
  styleUrls: ['./feed-advice-type-dialog.component.scss'],
  imports: [
    FormDialogComponent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    NgFor,
    MatOption,
    TranslatePipe,
  ],
})
export class FeedAdviceTypeDialogComponent extends AbstractFormDialog<FeedAdviceTypeDialogResultData> {
  formGroup: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FeedAdviceTypeDialogInputData,
    protected mdDialogRef: MatDialogRef<
      FeedAdviceTypeDialogComponent,
      AbstractDialogResultData<FeedAdviceTypeDialogResultData>
    >,
    private readonly locale: LocaleService,
  ) {
    super();

    this.data.title = this.locale.translate('select-feed-advice-type.title');

    this.formGroup = new FormGroup({
      feedAdviceType: new FormControl(null, [Validators.required]),
    });
  }

  getFeedadviceTypeLabel(type: { name: FeedAdviceType; period: string; type: string }) {
    let label = this.locale.translate('select-feed-advice-type.' + type.name);
    if (type.period !== '') {
      label = `${label} - ${this.locale.translate('select-feed-advice-type.' + type.period)}`;
    }
    return label;
  }

  save(): void {
    this.confirm({ feedAdviceType: this.formGroup.value.feedAdviceType });
  }
}
